const ExclusionListItem = ({ name, selected, enabled, onClick }) => {
  return (
    <div onClick={enabled ? onClick : null} className={`exclusion-list-item ${selected ? "selected" : ""}`}>
      {name}
    </div>
  );
};

export default ExclusionListItem;
